<template>
  <div class="my-2 full-width">
    <v-expansion-panels :value="0">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="clauseText--text medium-small-text-font align-self-start">
            4. Change the number in the blue cell below to see important data at a particular age of
            the youngest borrower.
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            class="d-flex flex1 flex-wrap align-center justify-space-between mb-10"
            style="column-gap: 24px"
          >
            <div min-width="400" max-width="1000" class="d-flex flex1 align-center">
              <NowVsFutureTableAB />
            </div>
            <div min-width="400" max-width="1000" class="d-flex flex1 align-center">
              <CustomScenarioChart :period="customChartPeriod" category="age" />
            </div>
          </div>

          <CashFlowImpactChart />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import CustomScenarioChart from '../../Charts/CustomScenarioChart.vue';
import NowVsFutureTableAB from '../../Tables/NowVsFutureTableAB.vue';
import CashFlowImpactChart from '../../Charts/CashFlowImpactChart.vue';
import helpers from '../../../helpers';

export default {
  components: {
    CustomScenarioChart,
    NowVsFutureTableAB,
    CashFlowImpactChart
  },
  computed: {
    customChartPeriod() {
      return (
        this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues
          .maxFutureAgeDiff - 1
      );
    }
  },
  methods: {
    formatMoney: helpers.formatMoney
  }
};
</script>
